import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";

export default function PromptTemplates() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/prompts").then((r) => setItems(r.data.items));
  useEffect(() => { load(); }, []);

  const save = async (key, body) => {
    await api.put(`/prompts/${key}`, { body });
    toast.success("Saved");
  };
  const reset = async (key) => {
    const { data } = await api.post(`/prompts/reset/${key}`);
    setItems((prev) => prev.map((p) => p.key === key ? data : p));
    toast.success("Reset to default");
  };

  return (
    <div className="p-8 md:p-10 max-w-4xl">
      <div className="overline text-[#B4533C]">Prompts</div>
      <h1 className="font-serif text-4xl mt-1 mb-6">AI Prompt Templates</h1>
      <p className="text-sm text-[#4A4742] mb-6">Edit the prompts used by AI assist in the article editor. Defaults are restored per-template via Reset.</p>
      {items.map((p) => (
        <div key={p.key} className="border border-[#D6CFC4] bg-white p-5 mb-5" data-testid={`prompt-${p.key}`}>
          <div className="flex items-center justify-between mb-3">
            <div>
              <div className="overline text-[#B4533C]">{p.key}</div>
              <div className="font-serif text-xl">{p.label}</div>
            </div>
            <div className="flex gap-2">
              <button onClick={() => reset(p.key)} className="border border-[#D6CFC4] px-3 py-1.5 text-xs">Reset</button>
              <button onClick={() => save(p.key, p.body)} className="bg-[#1B3B36] text-white px-3 py-1.5 text-xs" data-testid={`save-prompt-${p.key}`}>Save</button>
            </div>
          </div>
          <textarea
            value={p.body}
            onChange={(e) => setItems((prev) => prev.map((x) => x.key === p.key ? { ...x, body: e.target.value } : x))}
            rows={6}
            className="w-full border border-[#D6CFC4] px-3 py-2 text-sm font-mono"
          />
        </div>
      ))}
    </div>
  );
}
